import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Box, TrendingUp, Truck, BarChart3, Package } from "lucide-react";
import { BsStars } from "react-icons/bs";
import { BiChevronDown } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import {
  FillterFas,
  FilterMain,
  FilterProject,
  MainFilter,
} from "../../Redux/Slice/login/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import logo from "../../img/logo.png";

import {
  FaIndustry,
  FaWarehouse,
  FaBoxOpen,
  FaChartBar,
  FaClipboardList,
  FaTruck,
  FaCogs,
  FaBoxes,
  FaFileInvoice,
  FaBalanceScale,
  FaChartLine,
  FaTasks,
  FaLayerGroup,
  FaTshirt,
  FaTags,
  FaStore,
  FaShoppingCart,
  FaUserTie,
  FaUsers,
  FaCalendarAlt,
} from "react-icons/fa";

import {
  GiSewingMachine,
  GiRolledCloth,
  GiClothes,
  GiCottonFlower,
  GiThread,
  GiFabric,
  GiLargeDress,
  GiWool,
} from "react-icons/gi";

import {
  MdInventory,
  MdOutlineFactory,
  MdOutlineAssessment,
  MdOutlineLocalShipping,
} from "react-icons/md";

import {
  HiOutlineCube,
  HiOutlineChartBar,
  HiOutlineDocumentReport,
} from "react-icons/hi";
import { useLocation } from "react-router-dom";


import { useTheme } from "../../Themecontext/Themecontext";
import CustomMenuModal from "./CustomMenuModal";
import { baseMenuData } from "./menuConfig";
import { GetCustomMenu, SaveCustomMenu } from "../../Redux/Slice/UserRight/UserRightSlice";
import { Settings } from "lucide-react";


const Sidebar = () => {
  const location = useLocation();
  const firm = Cookies.get("Firm");
  const FinancialYear = Cookies.get("FinancialYear");
  const authToken = Cookies.get("authToken");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [openMenu, setOpenMenu] = useState(null);
  const [openSubMenus, setOpenSubMenus] = useState({});
  const [hoverIndex, setHoverIndex] = useState(null);
  const [activeSub, setActiveSub] = useState(null);
  const [showCustomMenuModal, setShowCustomMenuModal] = useState(false);

  useEffect(() => {
    const handleOpenCustomMenu = () => {
      setShowCustomMenuModal(true);
    };
    window.addEventListener("openCustomMenuModal", handleOpenCustomMenu);
    return () => {
      window.removeEventListener("openCustomMenuModal", handleOpenCustomMenu);
    };
  }, []);

  useEffect(() => {
    if (authToken) {
      dispatch(FilterProject());
      dispatch(GetCustomMenu());
    }
  }, dispatch);


  const { FilterProjectdata, Colourdata, verifyData } = useSelector(
    (state) => state.ClientLogin,
  );
  const { customMenu } = useSelector((state) => state.UserRightSlice);


  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;

  useEffect(() => {
    if (FilterProjectdata?.Project_list?.length > 0) {

      const existingProjectId =
        localStorage.getItem("projectId");

      if (existingProjectId) {
        return;
      }

      const greyProject =
        FilterProjectdata.Project_list.find(
          (item) =>
            item.DashboardProjectName === "GREY"
        );

      if (greyProject) {
        localStorage.setItem(
          "projectId",
          greyProject.DashboardProjectID
        );

        dispatch(MainFilter({}));
      }
    }
  }, [FilterProjectdata]);

  const projectApiMap = {
    FAS: (dispatch, firm, FinancialYear) =>
      dispatch(
        FillterFas({
          FirmIDs: firm,
          AcYearIDs: FinancialYear,
        }),
      ),
    GREY: (dispatch, firm, FinancialYear) =>
      dispatch(
        FilterMain({
          FirmIDs: firm,
          AcYearIDs: FinancialYear,
        }),
      ),
    // PAYROLL: (dispatch, firm, FinancialYear) =>
    //   dispatch(
    //     FilterMain({
    //       FirmIDs: firm,
    //       AcYearIDs: FinancialYear,
    //     })
    //   ),
  };




  const handleProjectClick = (projectName) => {

    const projectMapping = {
      "MILL STAGE": "MILLSTAGE",
      MILLSTAGE: "MILLSTAGE",
      STORE: "MAINTENANCE",
      MAINTENANCE: "MAINTENANCE",
      GREY: "GREY",
      FAS: "FAS",
      PAYROLL: "PAYROLL",
      COLOUR: "COLOUR",
      "ORDER APPROVAL": "ORDER APPROVAL",
      ORDERAPPROVAL: "ORDER APPROVAL",
      "COLLECTION MAN": "COLLECTION MAN",
    };

    const matchedProject = FilterProjectdata?.Project_list?.find((item) => {
      const dbProjName = item.DashboardProjectName?.toUpperCase();
      const mappedName = projectMapping[dbProjName] || dbProjName;

      return mappedName === projectName?.toUpperCase();
    });

    if (!matchedProject) return;

    const { DashboardProjectID, DashboardProjectName } = matchedProject;

    localStorage.setItem("projectId", DashboardProjectID);

    const apiHandler = projectApiMap[DashboardProjectName];

    if (apiHandler) {
      apiHandler(dispatch, firm, FinancialYear);
    } else {
      console.warn("API not defined for:", DashboardProjectName);
    }
  };


  const customMenuSubmenu = [];
  const projectMap = {};

  customMenu.forEach((customItem) => {
    let foundProject = "OTHER";

    for (const menu of baseMenuData) {
      if (menu.name === "OVERALL DASHBOARD" || menu.name === "USER RIGHTS") continue;

      const hasPath = (items) => {
        if (!items) return false;
        for (const item of items) {
          if (item.path === customItem.path) return true;
          if (item.submenu && hasPath(item.submenu)) return true;
        }
        return false;
      };

      if (hasPath(menu.submenu)) {
        foundProject = menu.name;
        break;
      }
    }

    if (!projectMap[foundProject]) {
      projectMap[foundProject] = [];
      customMenuSubmenu.push({
        name: foundProject,
        icon: <Package size={16} />,
        submenu: projectMap[foundProject],
      });
    }

    projectMap[foundProject].push({
      name: customItem.name,
      icon: <FaChartBar size={16} />,
      path: customItem.path,
    });
  });

  const menuData = [
    {
      name: "MY CUSTOM MENU",
      icon: <Settings size={18} />,
      isCustomMenu: true,
      submenu: customMenuSubmenu,
    },
    ...baseMenuData
  ];

  const filteredMenuData = menuData.filter((menu) => {
    const role = Cookies.get("Role");
    const isCollectionMan = role?.toLowerCase() === "collection man";
    const isMillStageUser = role?.toLowerCase() === "millstageuser";

    if (isMillStageUser) {
      return menu.name === "MILLSTAGE ENTRY";
    }

    if (isCollectionMan) {
      return menu.name === "COLLECTION MAN";
    }

    if (menu.name === "MY CUSTOM MENU") {
      return true; // Always show custom menu
    }

    if (menu.name === "USER RIGHTS") {
      return role !== "User" && !isCollectionMan;
    }

    if (menu.name === "OVERALL DASHBOARD") {
      return true;
    }

    if (!FilterProjectdata?.Project_list) return false;
    const projectMapping = {
      "MILL STAGE": "MILLSTAGE",
      MILLSTAGE: "MILLSTAGE",
      STORE: "MAINTENANCE",
      MAINTENANCE: "MAINTENANCE",
      GREY: "GREY",
      FAS: "FAS",
      PAYROLL: "PAYROLL",
      COLOUR: "COLOUR",
      "ORDER APPROVAL": "ORDER APPROVAL",
      "OVERALL DASHBOARD": "OVERALL DASHBOARD",
      ORDERAPPROVAL: "ORDER APPROVAL",
      "COLLECTION MAN": "COLLECTION MAN",
    };

    return FilterProjectdata.Project_list.some((item) => {
      const dbProjName = item.DashboardProjectName?.toUpperCase();
      const mappedName = projectMapping[dbProjName] || dbProjName;
      return mappedName === menu.name?.toUpperCase();
    });

  }).map((menu) => {
    console.log("verifyData in Sidebar map:", verifyData?.AllowedPages);
    if (menu.submenu && menu.name !== "MY CUSTOM MENU" && menu.name !== "OVERALL DASHBOARD") {
      let allowedPages = verifyData?.AllowedPages;
      if (!allowedPages) {
        const stored = localStorage.getItem("AllowedPages");
        if (stored) {
          try { allowedPages = JSON.parse(stored); } catch (e) {}
        }
      }
      console.log(`Checking allowed pages for ${menu.name}:`, allowedPages);
      // USER REQUIREMENT: If AllowedPages is blank ([]), show full project (no filter).
      if (allowedPages && Array.isArray(allowedPages) && allowedPages.length > 0) {
        const filteredSubmenu = menu.submenu.filter(sub => allowedPages.includes(sub.path));
        return { ...menu, submenu: filteredSubmenu };
      }
    }
    return menu;
  }).filter(menu => {
    // If it's a project and its submenu is empty after filtering, don't show the project
    if (menu.name !== "MY CUSTOM MENU" && menu.name !== "OVERALL DASHBOARD" && menu.name !== "USER RIGHTS" && menu.submenu) {
       return menu.submenu.length > 0;
    }
    return true;
  });


  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
    setOpenSubMenus({});
  };

  const toggleSubMenu = (key) => {
    setOpenSubMenus((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const hasActiveChild = (items = []) => {
    return items.some((item) => {
      if (item.path === location.pathname) return true;

      if (item.submenu) {
        return hasActiveChild(item.submenu);
      }

      return false;
    });
  };

  const renderSubMenu = (items = [], parentKey = "", level = 0) => {

    return items.map((item, index) => {
      const itemKey = `${parentKey}-${index}`;
      const isHover = hoverIndex === itemKey;
      const isActive = activeSub === itemKey;
      const isOpen = openSubMenus[itemKey];
      const isNestedChild = level >= 2;
      const isCurrentPage = location.pathname === item.path;
      const isDropdownActive = item.submenu
        ? hasActiveChild(item.submenu)
        : false;

      if (item.submenu) {
        return (
          <div key={itemKey}>
            <Row
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                toggleSubMenu(itemKey);
              }}
              onMouseEnter={() => setHoverIndex(itemKey)}
              onMouseLeave={() => setHoverIndex(null)}
              style={{
                padding: "8px 10px",
                marginTop: "4px",
                alignItems: "center",
                borderRadius: "8px",
                cursor: "pointer",

                background:
                  isOpen || isDropdownActive
                    ? isdark === "light"
                      ? "rgba(59, 130, 246, 0.12)"
                      : "rgba(59, 130, 246, 0.25)"
                    : isHover
                      ? isdark === "light"
                        ? "rgba(59, 130, 246, 0.08)"
                        : "rgba(59, 130, 246, 0.18)"
                      : "transparent",
                color:
                  isOpen || isDropdownActive || isHover
                    ? isdark === "light"
                      ? "#000000"
                      : "#ffffff"
                    : isdark === "light"
                      ? "#64748B"
                      : "#94A3B8",
                borderLeft:
                  isHover || isOpen || isDropdownActive
                    ? "3px solid #3B82F6"
                    : "3px solid transparent",
                transition: "all 0.3s ease",
                marginLeft: level === 0 ? "0px" : "4px",
              }}
            >
              <Col
                xs="auto"
                style={{
                  background: "rgba(255,255,255,0.05)",
                  padding: "4px 6px",
                  borderRadius: "8px",
                }}
              >
                {item.icon || <Box size={14} />}
              </Col>

              <Col style={{ fontWeight: 500, fontSize: "13px" }}>
                {item.name}
              </Col>

              <Col xs="auto">
                <BiChevronDown
                  style={{
                    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "0.3s",
                  }}
                />
              </Col>
            </Row>

            <div
              style={{
                overflow: "hidden",
                transition: "all 0.35s ease",
                maxHeight: isOpen ? "1000px" : "0px",
                marginLeft: level === 0 ? "10px" : "12px",
                marginLeft: "12px",
                paddingLeft: "7px",
                marginTop: "10px",
                marginBottom: "12px",
                position: "relative", 
              }}
            >

              <div
                style={{
                  position: "absolute",
                  left: "0",
                  top: "0",
                  width: "2px",
                  height: isOpen ? "100%" : "0%",
                  background:
                    isdark === "light"
                      ? "rgb(100, 116, 139,0.5)"
                      : "rgb(100, 116, 139,0.6)",
                  transition: "height 0.4s ease",
                }}
              />

              {renderSubMenu(item.submenu, itemKey, level + 1)}
            </div>
          </div>
        );
      }



      return (
        <Row
          key={itemKey}
          onClick={() => {
            setActiveSub(itemKey);
            navigate(item.path);
          }}
          onMouseEnter={() => setHoverIndex(itemKey)}
          onMouseLeave={() => setHoverIndex(null)}
          style={{
            padding: isNestedChild ? "7px 8px" : "8px 10px",
            marginTop: "4px",
            alignItems: "center",
            borderRadius: "8px",
            cursor: "pointer",
            background: isCurrentPage
              ? isdark === "light"
                ? "rgba(59, 130, 246, 0.12)"
                : "rgba(59, 130, 246, 0.25)"
              : isHover
                ? isdark === "light"
                  ? "rgba(59, 130, 246, 0.08)"
                  : "rgba(59, 130, 246, 0.18)"
                : "transparent",
            color:
              isCurrentPage || isHover
                ? isdark === "light"
                  ? "#000000"
                  : "#ffffff"
                : isdark === "light"
                  ? "#64748B"
                  : "#94A3B8",
            borderLeft: isCurrentPage
              ? "3px solid #3B82F6"
              : "3px solid transparent",
            transition: "all 0.3s ease",
            marginLeft: isNestedChild ? "4px" : `${level * 6}px`,
          }}
        >
          {!isNestedChild && (
            <Col
              xs="auto"
              style={{
                // background: "rgba(255,255,255,0.05)",
                padding: "4px 6px",
                borderRadius: "8px",
              }}
            >
              {item.icon || <Box size={14} />}
            </Col>
          )}

          <Col
            style={{
              fontWeight: 500,
              fontSize: isNestedChild ? "12.5px" : "13px",
              paddingLeft: isNestedChild ? "8px" : "0px",
            }}
          >
            {item.name}
          </Col>
        </Row>
      );
    });
  };

  return (
    <div
      style={{
        width: "300px",
        height: "100vh",
        background: isdark === "light" ? "#F1F5F9" : "#020617",
        color: "white",
        position: "relative",
      }}
    >
      <div
        style={{
          padding: "20px",
          borderBottom: `1px solid ${isdark === "light"
            ? "rgba(14, 13, 13, 0.15)"
            : "rgba(253, 241, 241, 0.18)"
            }`,
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          style={{
            width: "180px",
            height: "50px",
          }}
          src={logo}
        />
      </div>

      <div
        className="sidebar-scroller"
        style={{
          padding: "20px",
          overflowY: "auto",
          overflowX: "hidden",
          height: "calc(100vh - 100px)",
        }}
      >
        {filteredMenuData.map((menu, index) => {
          const isMenuActive = menu.submenu
            ? hasActiveChild(menu.submenu)
            : menu.path === location.pathname;

          return (
            <div key={index}>
              <Row
                onClick={() => {
                  handleProjectClick(menu.name);
                  if (menu.submenu) {
                    toggleMenu(menu.name);
                  } else if (menu.path) {
                    navigate(menu.path);
                    setActiveSub(menu.name);
                  }
                }}
                style={{
                  padding: "20px 10px",
                  borderRadius: "12px",
                  cursor: "pointer",
                  alignItems: "center",

                  background:
                    openMenu === menu.name || isMenuActive
                      ? isdark === "light"
                        ? "rgba(59, 130, 246, 0.12)"
                        : "rgba(59, 130, 246, 0.25)"
                      : hoverIndex === index
                        ? isdark === "light"
                          ? "rgba(59, 130, 246, 0.08)"
                          : "rgba(59, 130, 246, 0.18)"
                        : "transparent",

                  borderLeft:
                    openMenu === menu.name || isMenuActive
                      ? "3px solid #3B82F6"
                      : "3px solid transparent",

                  marginBottom: "8px",
                }}
              >
                <Col
                  xs="auto"
                  style={{
                    color: isdark === "light" ? "#000000" : "#ffffff",
                    borderRadius: "10px",
                  }}
                >
                  {menu.icon}
                </Col>

                <Col
                  style={{
                    fontWeight: 600,
                    color: isdark === "light" ? "#000000" : "#ffffff",
                  }}
                >
                  {menu.name}
                </Col>

                {menu.submenu && (
                  <Col xs="auto">
                    <BiChevronDown
                      style={{
                        color: isdark === "light" ? "#000000" : "#ffffff",
                        transform:
                          openMenu === menu.name
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        transition: "0.3s",
                      }}
                    />
                  </Col>
                )}
              </Row>

              {menu.submenu && (
                <div
                  style={{
                    overflow: "hidden",
                    transition: "all 0.35s ease",
                    maxHeight: openMenu === menu.name ? "3000px" : "0px",
                    marginLeft: "5px",
                    paddingLeft: "17px",
                    marginTop: "10px",
                    marginBottom: "12px",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      position: "absolute",
                      left: "0",
                      top: "0",
                      width: "2px",
                      height: openMenu === menu.name ? "100%" : "0%",
                      background:
                        isdark === "light"
                          ? "rgb(100, 116, 139,0.5)"
                          : "rgb(100, 116, 139,0.6)",
                      transition: "height 0.4s ease",
                    }}
                  />

                  {renderSubMenu(menu.submenu, `${index}`, 0)}
                </div>
              )}
            </div>
          );
        })}
      </div>

      <CustomMenuModal
        show={showCustomMenuModal}
        onHide={() => setShowCustomMenuModal(false)}
        menuData={menuData}
      />
    </div>
  );
};

export default Sidebar;
